import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ImageManager } from "@/components/ImageManager";
import { api, formatError } from "@/lib/api";

export const PhotoDialog = ({ product, onClose, onSaved }) => {
  const [images, setImages] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => { setImages(product?.images || []); }, [product]);

  const save = async () => {
    setSaving(true);
    try {
      await api.patch(`/admin/products/${product.id}`, { images });
      toast.success("Foto aggiornate");
      onSaved();
      onClose();
    } catch (e) {
      toast.error("Errore salvataggio", { description: formatError(e.response?.data?.detail) || e.message });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!product} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="photo-dialog" className="max-w-2xl rounded-2xl">
        <DialogHeader>
          <DialogTitle className="font-heading text-brand-blue truncate pr-6">Foto – {product?.title}</DialogTitle>
        </DialogHeader>
        <ImageManager images={images} onChange={setImages} />
        <div className="flex justify-end gap-2">
          <Button variant="outline" data-testid="photo-dialog-cancel" onClick={onClose} className="rounded-full">Annulla</Button>
          <Button data-testid="photo-dialog-save" onClick={save} disabled={saving} className="rounded-full bg-brand-blue text-white">
            {saving ? "Salvataggio..." : "Salva foto"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
